import React from "react";

function MetricsView() {
  return <div>MetricsView</div>;
}

export default MetricsView;
